import ExportButtons from "components/buttons/ExportButtons";
import {
  useExportAssetMaintenanceCostsPerAsset,
  useExportAssetMaintenanceCostsPerType,
  useExportAssetMaintenances,
} from "hooks/queries/useAssetReports";
import {
  downloadBlobFile,
  resolveReportDownloadFilename,
} from "utils/reportDownload";

import { useAlert } from "hooks/useAlert";
import PropTypes from "prop-types";
import { useCallback, useEffect, useState } from "react";

const exportButtonsToDisplay = ["pdf", "excel", "csv"];

const AssetReportsExportButtons = ({ filters, reportType, reportLabel }) => {
  const { showError } = useAlert();
  const [selectedExportType, setSelectedExportType] = useState(null);

  const getFetchFunctionByReportType = (reportType) => {
    switch (reportType) {
      case "ExpiringMaintenances":
      case "CompletedMaintenances":
        return useExportAssetMaintenances;
      case "MaintenanceCostsPerAsset":
        return useExportAssetMaintenanceCostsPerAsset;
      case "MaintenanceCostsPerType":
        return useExportAssetMaintenanceCostsPerType;
      default:
        return null;
    }
  };

  const fetchFunction = useCallback(getFetchFunctionByReportType(reportType), [
    reportType,
  ]);

  const { data, isLoading, isError, refetch } = fetchFunction({
    exportType: selectedExportType,
    ...filters,
  });

  const handleExport = useCallback((type) => {
    setSelectedExportType(type);
  }, []);

  const handleDownload = useCallback(() => {
    const fileName = resolveReportDownloadFilename({
      headers: data?.headers,
      reportLabel,
      exportType: selectedExportType,
    });

    downloadBlobFile({ data: data?.data, fileName });
    setSelectedExportType(null);
  }, [data, reportLabel, selectedExportType]);

  useEffect(() => {
    if (selectedExportType) {
      refetch();
    }
  }, [refetch, selectedExportType]);

  useEffect(() => {
    if (data) {
      handleDownload();
    }

    if (isError) {
      setSelectedExportType(null);
      showError("Παρουσιάστηκε πρόβλημα κατά την εξαγωγή του αρχείου.");
    }
  }, [data, handleDownload, isError, showError]);

  return (
    <ExportButtons
      exportButtons={exportButtonsToDisplay}
      onPdfExport={() => handleExport("pdf")}
      onExcelExport={() => handleExport("excel")}
      onCsvExport={() => handleExport("csv")}
      isLoading={isLoading}
    />
  );
};

AssetReportsExportButtons.propTypes = {
  filters: PropTypes.object.isRequired,
  reportLabel: PropTypes.string.isRequired,
  reportType: PropTypes.string.isRequired,
};

export default AssetReportsExportButtons;
